export default {
    title: 'Assign to PBS',
    assignedPbs: 'Assigned PBS',
    assignNewPBS: 'Assign new PBS',
    confirmAdd: {
        messageFile: 'Are you sure you want to assign PBS {name} to this file?',
        messageFolder: 'Are you sure you want to assign PBS {name} to this folder?',
        title: 'Assign PBS',
        successFile: 'Assign PBS to file successfully',
        successFolder: 'Assign PBS to folder successfully',
    },
    confirmRemove: {
        messageFile: 'Are you sure you want to remove PBS {name} from this file?',
        messageFolder: 'Are you sure you want to remove PBS {name} from this folder?',
        title: 'Remove PBS',
        successFile: 'Remove PBS from file successfully',
        successFolder: 'Remove PBS from folder successfully',
    },
    button: {
        delete: 'Delete',
    },
    filterForm: {
        keyword: {
            placeholder: 'Enter keyword',
        },
    },
};
